import {ready} from '~/core'
ready('navSecondary', '.navSecondary', (navSecondary) => {
  let media = window.matchMedia("(min-width: 1024px)");
  let nav = document.querySelector('.navSecondary')
  let mobileToggle = document.querySelector('.navSecondary-mobileToggle')
  let subNavs = [...document.querySelectorAll('.navSecondary-itemList')]
  let navItems = document.querySelectorAll('.navSecondary-item')

  for(let subNav of subNavs) {
    let span = document.createElement('span');
    span.className = 'navSecondary-subToggle';

    span.addEventListener('click', function() {
      if(!this.parentNode.classList.contains('active')) {
        this.parentNode.classList.add('active')
      } else  {
        this.parentNode.classList.remove('active')
      }
    })

    subNav.parentNode.insertBefore(span, subNav)
  }

  mobileToggle.addEventListener('click', function() {
    if(!nav.classList.contains('is-expanded')) {
      nav.classList.add('is-expanded')
    } else  {
      nav.classList.remove('is-expanded')
    }
  })

  function reset() {
    nav.classList.remove("is-expanded")
      for(let item of navItems) {
        item.classList.remove('active')
      }
  }

  media.addListener((e) => {
		if (e.matches) {
      reset()
		} else {
      for(let item of navItems) {
        item.classList.remove('active')
      }
    }
	})

})